module.exports = __webpack_public_path__ + "media/components/Influencers/Layouts/Navigation/mypageIcon-4bfbef819967bdd78b6108177a832eb4.svg";